import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { PasswordValidationRequest } from './passwordvalidationrequest';

export class PasswordValidationAPI extends APIImpl<PasswordValidationRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/password-validation
        return "password-validation";
    }

    getRequestData()
    {
        return "msisdn=" + this.getRequest().getPasswordValidationRequest().getMsisdn() +"&"+
               "encryptedPassword="+ this.getRequest().getPasswordValidationRequest().getEncryptedPassword() +"&"+
               "language="+ this.getRequest().getPasswordValidationRequest().getLanguage() +"&"+
              "type="+ "ValidateDetails" +"&"+
               "securityCounter="+ this.getRequest().getPasswordValidationRequest().getSecurityCounter()+"&"+
               "clientTxnId="+ "21042020";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationapi.tsx